<template>
  <section class="ui-modal-section">
    <slot />
  </section>
</template>
